<template>
	<div :class="calendarClass">
		<table class="tbl_month">
			<caption class="sr_only">일주일요일과 한달날짜</caption>
			<thead>
				<tr>
					<th v-for="day in weekdays">{{day}}</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="week in currentCalendar">
					<date v-for="date in week" :year="_year" :month="_month" :date="date" :schedules="_schedules"></date>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
	import { mapState } from 'vuex';

	import calendar from 'calendar-js';

	import Date from './Date.vue';

	import { generateScheduleMap, filterSchedules } from '@src/schedule/common';

	export default {
		components: { Date },

		props: {
			isCenter: {
				type: Boolean,
				default: false,
			},
			year: Number,
			month: Number,
		},
		data() {
			return {
				weekdays: ['일', '월', '화', '수', '목', '금', '토'],
			};
		},
		computed: {
			...mapState(['schedules', 'selectedCategory']),
			currentCalendar() {
				return calendar().of(this._year, this._month).calendar;
			},

			_year() {
				if (this.month === 12) return this.year + 1;
				if (this.month === -1) return this.year - 1;
				return this.year;
			},
			_month() {
				if (this.month === 12) return 0;
				if (this.month === -1) return 11;
				return this.month;
			},

			_schedules() {
				return generateScheduleMap(filterSchedules(this.schedules, {
					year: this._year,
					month: this._month,
					category: this.selectedCategory,
				}));
			},

			calendarClass() {
				return {
					tbl_calendar: true,
					center: this.isCenter,
				};
			},
		},
		watch: {
			currentCalendar(calendar) {
				this.$emit('calendar-length-change', calendar.length);
			},
		},
	}
</script>
